module.exports = __webpack_public_path__ + "img/AMD.69727bec.svg";